import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/qrcodeTemplate/importer/qrcodeTemplateImporterActions';

export default importerReducers(actions);
